import { useApi } from '@/api';
import { ChartTimeFilter, ChartSkeleton } from '@/components';
import { Flex } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import DatesLiquidationsGraph, { DatesData } from '../DatesLiquidationsGraph';

export default function HistoricTabs({ ilk }) {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');

  const timeFilter = useMemo(
    () => (
      <ChartTimeFilter activeOption={chartDaysAgo} onChange={setChartDaysAgo} />
    ),
    [chartDaysAgo]
  );

  const [data, error] = useApi<DatesData>({
    url: `/liquidations/historic/`,
    queryParams: {
      days_ago: chartDaysAgo,
      type: 'date',
      ilk: ilk
    }
  });

  if (error) {
    throw error;
  }

  const content = useMemo(() => {
    return (
      <DatesLiquidationsGraph
        data={data as DatesData}
        timeFilter={timeFilter}
        daysAgo={Number(chartDaysAgo)}
      />
    );
  }, [data, timeFilter, chartDaysAgo]);

  if (data) {
    return (
      <Flex flexDirection="column" gap="xs">
        {content}
      </Flex>
    );
  }

  return <ChartSkeleton />;
}
